export enum FormId {
  LoginForm = 'loginForm',
  CreateUserForm = 'createUserForm',
  EditUserForm = 'editUserForm',
  ChangePasswordForm = 'changePasswordForm',
  EditClientForm = 'editClientForm',
  AddClientForm = 'addClientForm',
  EventForm = 'eventForm',
  AddEventVideoForm = 'addEventVideoForm',
  UploadParticipants = 'uploadParticipants',
  AddParticipants = 'addParticipants',
  AddUnknownParticipant = 'addUnknownParticipant',
  UploadAegisubResult = 'uploadAegisubResult',
  ShopForm = 'shopForm',
  EditParticipant = 'editParticipant',
  GetDetailsFromParticipant = 'getDetailsFromParticipant',
  SendParticipantsToGenerator = 'sendParticipantsToGenerator',
  SendLiveParticipantsToGenerator = 'sendLiveParticipantsToGenerator',
  SendParticipantsToRRE = 'sendParticipantsToRRE',
  SendLiveParticipantsToRRE = 'sendLiveParticipantsToRRE',
  ConvertToUnknownParticipant = 'convertToUnknownParticipant',
  CopyClipConfigurationFromClient = 'copyClipConfigurationFromClient',
  ClientsUserAdd = 'clientsUserAdd',
  ClientsUserEdit = 'clientsUserEdit',
  UpdateClipTemplateConfig = 'UpdateClipTemplateConfig',
  ClipTemplateConfigPreview = 'ClipTemplateConfigPreview',
  GenerateVgVideoCeremony = 'generateVgVideoCeremony',
  CreateAfterEffectsParticipantForm = 'createAfterEffectsParticipantForm',
  EditAfterEffectsParticipantForm = 'editAfterEffectsParticipantForm',
  CreateAfterEffectsChapterForm = 'createAfterEffectsChapterForm',
  EditAfterEffectsChapterForm = 'editAfterEffectsChapterForm',
  DownloadSummaryForm = 'downloadSummaryForm',
  NlpForm = 'NlpForm',
  UnlockTemplateForm = 'unlockTemplateForm',
  UnlockClip = 'unlockClip',
  ResetRender = 'resetRender',
}
